var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{class:{
      'text-xs-center': _vm.center
  },attrs:{"justify-center":_vm.center}},[_c('h3',{staticClass:"primary--text text-uppercase textoAjustado"},[_vm._t("default")],2)]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":"","mb-3":""}},[_c('v-divider',{staticClass:"dividerSubtitle primary"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d2cb93","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/titulos/OMediumTitle.vue
// module id = null
// module chunks = 